import { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import Select from "react-select";
import _ from "lodash";

import classes from "../maintainers.module.scss";
import { customStyles } from "./codes.constants";
import { useCodesPaginate } from "@/hooks/maintainers/codes";
import { useSelector } from "react-redux";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const options = [
	{
		value: "all",
		label: "Ver Todos",
	},
	{
		value: "deleted",
		label: "Eliminados",
	},
	{
		value: "active",
		label: "Activos",
	},
];

const CodesFilter = ({ base, applyFilter }) => {
	const { search } = useSelector((state) => state.auth.filter);

	const { data } = useCodesPaginate({
		...base,
		search,
	});

	const [filterCustomer, setFilterCustomer] = useState(base.customer_id);
	const [filterStatus, setFilterStatus] = useState(base.status);

	const handleApplyFilter = () => {
		applyFilter({
			filterCustomer,
			filterStatus,
		});
	};

	const handleCleanFilter = () => {
		applyFilter({
			filterCustomer: "",
			filterStatus: "",
		});
	};

	return (
		<Col md={3} className={classes.filter}>
			<h4 className={classes.filterTitle}>Filtros</h4>
			<hr style={{ marginTop: "0.5em", marginBottom: "0.5em" }} />

			<div className={classes.divContent}>
				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Cliente</span>
					</Col>

					<Col md={12}>
						<Select
							value={
								data &&
								data.customers &&
								data.customers.filter(
									(a) => filterCustomer && filterCustomer.length > 0 && _.map(filterCustomer.split(","), Number).includes(Number(a.value)),
								)
							}
							isMulti
							placeholder={<div>Seleccione</div>}
							options={data && data.customers ? data && data.customers : []}
							onChange={(value) => {
								let baseValue = [];
								value.forEach((element) => {
									baseValue.push(element.value);
								});

								setFilterCustomer(baseValue.length !== 0 ? baseValue.toString() : "");
							}}
							components={{ NoOptionsMessage }}
							styles={customStyles}
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Estado</span>
					</Col>

					<Col md={12}>
						<Select
							value={options.filter((a) => a.value === filterStatus)}
							placeholder={<div>Seleccione</div>}
							options={options}
							onChange={(value) => {
								setFilterStatus(value.value);
							}}
							components={{ NoOptionsMessage }}
							styles={customStyles}
						/>
					</Col>
				</Row>
			</div>

			<div className={classes.divFooter}>
				<Button className={classes.buttonClean} onClick={() => handleCleanFilter()}>
					Limpiar
				</Button>

				<Button className={classes.buttonApply} onClick={() => handleApplyFilter()}>
					Aplicar
				</Button>
			</div>
		</Col>
	);
};

export default CodesFilter;
